<template>
  <v-container grid-list-xl>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout>
          <v-flex xs12 md12>
            <v-autocomplete
              :items="filteredPartners"
              item-text="name"
              item-value="partner_id"
              prepend-icon="flash_on"
              label="Parceiro"
              v-model="partner"
              return-object
              :rules="[(v) => !!v || 'Selecione o Parceiro.']"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md4 d-flex>
            <v-flex xs12 md12 class="text-lg-right">
              <v-btn
                color="primary"
                @click="validate()"
                :disabled="!valid || loading"
              >
                <v-icon>chart-bell-curve</v-icon>OK
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { EventBus } from "../../../utils/event-bus";
// import { GET_ALL_BILLING_TOTAL } from '../../graphql/billing';
import { GET_POWER_PLANT } from "../../../graphql/powerplants";
import { GET_BALANCE } from "../../../graphql/balance";
import { mapState } from "vuex";

export default {
  data: () => ({
    loading: false,
    valid: false,
    partners: [],
    partner: "",
    powerplant: "",
    balance: {},
    // invoices: [],
    // consumerunits: []
  }),
  mounted() {
    EventBus.$on("PowerPlant", (power_plant) => {
      this.loading = true;
      this.powerplant = power_plant;
      this.$apollo
        .query({
          query: GET_POWER_PLANT,
          variables: {
            id: power_plant,
          },
        })
        .then((power_plant) => {
          // Seta as faturas no eventBus para o outro Componente
          this.partners = power_plant.data.powerplant.owners;
          this.valid = true;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.valid = true;
          this.loading = false;
        });
    });
  },
  computed: {
    ...mapState(["user"]),
    filteredPartners() {
      // if(this.user.group === 'admin')
      if (
        this.user &&
        this.user.group &&
        (this.user.group.indexOf("admin") >= 0 ||
          this.user.group.indexOf("financial") >= 0)
      ) {
        return this.partners;
      }

      var PartnerArray = [];
      this.partners.filter((partner) => {
        // console.log('partner: ', partner)
        // console.log('user_partner_id: ', this.user.partner_id)
        if (this.user.partner_id === partner.partner_id)
          PartnerArray.push(partner);
      });

      // console.log('PartnerArray: ', PartnerArray)
      if (PartnerArray.length === 1) {
        // eslint-disable-next-line
        this.partner = PartnerArray[0];
        this.getBalance(this.partner.recipient_id);
      }
      return PartnerArray;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        ((this.valid = true), (this.loading = true));
        this.getBalance(this.partner.recipient_id);
      }
    },
    getBalance(recipient_id) {
      this.$apollo
        .query({
          // gql query
          query: GET_BALANCE,
          // Reactive parameters
          variables: {
            // Use vue reactive properties here
            id: recipient_id,
          },
        })
        .then((balance) => {
          // Seta as faturas no eventBus para o outro Componente
          this.balance = balance.data.balance;
          // console.log('balance: ', balance.data.balance)
          EventBus.$emit("LoadBalance", this.balance);
          this.valid = true;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.valid = true;
          this.loading = false;
        });
    },
  },
  beforeDestroy() {
    //do something before destroying vue instance
    EventBus.$off("PowerPlant");
  },
};
</script>
